<div class="cdw-search-input-wrapper">
  <mat-form-field
    appearance="outline"
    class="custom-search-field"
    [style.width]="'100%'"
    [style.height]="height"
    [style.--custom-bg-color]="backgroundColor"
    [style.--custom-icon-color]="iconColor">
    <input
      matInput
      type="text"
      [formControl]="searchControl"
      [placeholder]="placeholder"
      [matAutocomplete]="auto"
      class="custom-search-input"
    />
    <lib-cdw-icon matPrefix class="search-icon" [icon]="iconPrefix"></lib-cdw-icon>
  </mat-form-field>
  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="displayItem"
    (optionSelected)="onItemSelected($event)"
    class="user-autocomplete"
    panelClass="cdw-search-autocomplete-panel"
    autoActiveFirstOption>
    <mat-option *ngFor="let item of filteredItems$ | async" [value]="item" class="user-option">
      <lib-cdw-user-option
        [name]="$any(item[displayField])"
        [email]="secondaryField ? $any(item[secondaryField]) : undefined">
      </lib-cdw-user-option>
    </mat-option>
  </mat-autocomplete>
</div>
